import { ChevronDown, ChevronUp } from "lucide-react";

/** How a sortable column is sorted now. `false` is not sorted. */
export type SortDirection = "asc" | "desc" | false;

/**
 * The arrow beside a sortable column header: up for ascending, down for
 * descending, and a muted up-down pair while the column is not sorted.
 * `<DataTable>` and the hand-built tables share it, so a sortable header
 * looks the same on every surface.
 */
export function SortIndicator({ direction }: { direction: SortDirection }) {
  return (
    <span className="text-text-dim">
      {direction === "asc" ? (
        <ChevronUp size={14} className="text-foreground" />
      ) : direction === "desc" ? (
        <ChevronDown size={14} className="text-foreground" />
      ) : (
        <ChevronsUpDownTiny />
      )}
    </span>
  );
}

function ChevronsUpDownTiny() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <path
        d="M4 5.5 L7 3 L10 5.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 8.5 L7 11 L10 8.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
